<template>
    <div class="header-account__menu-content d-flex">
        <div class="dropdown-remove-arrow dropdown-remove-padding d-flex">
            <b-dropdown right>
                <template slot="button-content">
                    <span class="header-account__menu-link d-block"><iconAddAction class="d-block"/></span>
                </template>

                <b-dropdown-item
                    v-if="userIsAthlete && canViewLudumFeature($options.LUDUM_SUBSCRIPTION_FEATURES.MORNING_MONITORING)"
                    @click="openMorningMonitoring()"
                >
                    {{ $t('addMorningMonitoring') }}
                </b-dropdown-item>
                <b-dropdown-item
                    :to="{
                        name: $options.ROUTES_PROFILE_NOTES,
                        params: { id: me.id },
                        hash: '#open'
                    }"
                >
                    {{ $t('addPrivateNote') }}
                </b-dropdown-item>
                <b-dropdown-item @click="openAddSessionResults()">
                    {{ $t('addResults') }}
                </b-dropdown-item>
                <b-dropdown-item v-if="canInviteMembers()" :to="{ name: $options.ROUTES_ADD_MEMBER }">
                    {{ $t('addMember') }}
                </b-dropdown-item>
                <b-dropdown-item @click="openCreateSession()">
                    {{ $t('newSession') }}
                </b-dropdown-item>
                <b-dropdown-item @click="openCreateEvent()">
                    {{ $t('newEvent') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import { ADD_SESSION_RESULTS, CREATE_MORNING_MONITORING } from '@/constants/modals';
import { DATE_FORMAT_API } from '@/constants/dateTimeFormats';
import { ROUTES_ADD_MEMBER, ROUTES_PROFILE_NOTES } from '@/constants/routes';
import { LUDUM_SUBSCRIPTION_FEATURES } from '@/constants';
import { mapActions, mapGetters } from 'vuex';
import permissionsMixin from '@/mixins/permissions';
import sessionMixin from '@/mixins/session';
import iconAddAction from '@/assets/img/account/header/add-action.svg?inline';

export default {
    components: {
        iconAddAction
    },

    mixins: [permissionsMixin, sessionMixin],

    LUDUM_SUBSCRIPTION_FEATURES,
    ROUTES_ADD_MEMBER,
    ROUTES_PROFILE_NOTES,

    methods: {
        ...mapActions(['setModalOpen']),

        openAddSessionResults() {
            this.$store.dispatch('setModalOpen', ADD_SESSION_RESULTS);
        },

        openMorningMonitoring() {
            this.$store.dispatch('createMorningMonitoring/setEditMorningMonitoring', {
                id: this.me.id,
                date: moment().format(DATE_FORMAT_API)
            });
            this.$store.dispatch('setModalOpen', CREATE_MORNING_MONITORING);
        }
    },

    computed: {
        ...mapGetters({
            me: 'clubHelper/me',
            userIsAthlete: 'isCurrentUserAthleteOfSelectedClub'
        })
    }
};
</script>
